import * as types from './types'
import storage from '@/plugins/storage'
import globals from '@/plugins/globals.js'
import moment from 'moment'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.CHAT_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.local.setItem(types.CHAT_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.CHAT_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.CHAT_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.CHAT_FILTER_BY, filterBy)
  },
  [types.SET_CHECKED](state, data) {
    for (let channel of state.channels.items) {
      if (channel.id === data.id) {
        channel.isChecked = data.isChecked
      }
    }
    state.isChecked = false
    for (let channel of state.chatgroups) {
      if (channel.isChecked) {
        state.isChecked = true
        break
      }
    }
  },
  [types.RESET_CHANNELS](state) {
    state.isChecked = false
    state.channels = []
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.SET_CHANNELS](state, data) {
    state.isChecked = false
    if (data) {
      state.channels = data
      state.channels.items.forEach(element => {
        element.isChecked = false
      })
    }
  },
  [types.SET_CHATGROUPS](state, data) {
    state.isChecked = false
    if (data !== undefined && data !== null) {
      if (data.response !== undefined && data.response !== null) {
        state.chatgroups = state.chatgroups.concat(data.response.groups)
        state.lastFetchTime = data.response.lastFetchTime
        state.chatgroups.forEach(element => {
          element.isChecked = false
        })
      }
    }
  },
  [types.UPDATE_CHATGROUP](state, id) {
    let found = state.chatgroups.find(x => x.id === id)
    if (found !== undefined && found !== null) {
      found.isChecked = !found.isChecked
    }
    state.isChecked = false
    let foundChecked = state.chatgroups.find(x => x.isChecked)
    if (foundChecked !== undefined && foundChecked !== null) {
      state.isChecked = true
    }
  },
  [types.SET_CHATGROUP](state, data) {
    state.chatgroup = data
  },
  [types.SET_CHATMESSAGES](state, data) {
    state.messages = []
    console.log('ChatAdmin: set Chat Messages', data)
    if (data) {
      if (!globals.isEmpty(data.channels)) {
        if (data.channels[data.id]) {
          let last = ''
          data.channels[data.id].forEach(element => {
            let type = 'received'
            if (element.uuid === last) {
              type = 'sent'
            }
            let timetoken = parseFloat(element.timetoken) / 10000000
            state.messages.push({
              createdOn: moment.unix(timetoken).calendar(),
              name: null,
              type: type,
              message: element.message,
              isTitle: false
            })
            last = element.uuid
          })
        }
      }
      // if (data.response !== undefined && data.response !== null) {
      //   incoming = data.response.message
      // } else {
      //   incoming = data
      // }
      // if (incoming !== undefined && incoming !== null) {
      //   let profile = store.getters['auth/profile']
      //   if (incoming.length > 0) {
      //     incoming.forEach(element => {
      //       if (element.source !== 4) {
      //         let type = 'received'
      //         if (element.to === profile.username) {
      //           type = 'sent'
      //         }
      //         state.messages.push({
      //           createdOn: moment(element.createdAtTime).calendar(),
      //           name: element.to,
      //           type: type,
      //           message: element.message,
      //           isTitle: false
      //         })
      //       }
      //     })
      //   }
      //   state.messages.reverse()
      //   store.dispatch('chat/setMessages', state.messages)
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/mutations.js